export enum ConfigurationEnvironmentEnum {
  DEVELOPMENT = "development",
  PRODUCTION = "production",
}

export type Configuration = {
  environment: ConfigurationEnvironmentEnum | null;
};
